function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { omit, get } from 'lodash';
import { InputField } from '@unite-us/app-components';
import { getPreferredProp } from '@unite-us/ui';
var dollarsToCents = function dollarsToCents(dollarValue) {
  var centValue = parseFloat(dollarValue) * 100;
  return Math.abs(parseInt(centValue.toFixed(2), 10));
};
var CurrencyField = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useImperativeHandle(ref, function () {
    return {
      props: props
    };
  });
  var reduxOnChange = getPreferredProp(props, 'onChange');
  var reduxOnBlur = getPreferredProp(props, 'onBlur');
  var toDollarValue = function toDollarValue(centValue) {
    var floatNum = parseFloat(centValue) / 100;
    return Number.isNaN(floatNum) ? '' : floatNum;
  };
  var onChange = function onChange(event) {
    var value = get(event, 'target.value', '');
    reduxOnChange(dollarsToCents(value));
  };
  var onBlur = function onBlur(event) {
    var value = get(event, 'target.value', '');
    reduxOnBlur(dollarsToCents(value));
  };
  var value = getPreferredProp(props, 'value');
  var inputProps = omit(props, ['field.onBlur', 'field.onChange', 'field.initialValue', 'field.value', 'input.onBlur', 'input.onChange', 'input.value', 'meta.initial']);
  var dollarValue = toDollarValue(value);
  return /*#__PURE__*/React.createElement(InputField, _extends({}, inputProps, {
    onChange: onChange,
    onBlur: onBlur,
    type: "number",
    placeholder: "0.00",
    step: "0.1",
    value: dollarValue
  }));
});
CurrencyField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  field: PropTypes.object
};
CurrencyField.defaultProps = {
  onChange: null,
  onBlur: null,
  value: '',
  field: null
};
export default CurrencyField;
//# sourceMappingURL=index.js.map